import React, { useState } from "react";
import { eventCardMedia } from "../../utils/publicEventsApi";

const FALLBACK = "/smym-logo-no-bg.png?v=20261103";

export default function PastEventThumbnail({ event }) {
  const { src, fit } = eventCardMedia(event);
  const [failedSrc, setFailedSrc] = useState(null);
  const useImage = src && failedSrc !== src;
  return (
    <img
      className="smym-past-event-thumb"
      src={useImage ? src : FALLBACK}
      alt=""
      loading="lazy"
      decoding="async"
      style={{ objectFit: useImage ? fit : "contain" }}
      onError={() => setFailedSrc(src)}
    />
  );
}
